const custom_fonts = [
    {
        font:'SimSun',
        url:'https://paper-airplane.oss-cn-beijing.aliyuncs.com/2024/09/03/29ff2d32-e8fd-442a-90ac-ce137447814c.woff2',
    },
    {
        font:'KaiTi',
        url:'https://paper-airplane.oss-cn-beijing.aliyuncs.com/2024/09/03/0d74ecf8-f226-4451-9157-60b505c89427.woff2',
    },
    {
        font:'Times New Roman',
        url:'https://paper-airplane.oss-cn-beijing.aliyuncs.com/2024/09/03/2d85d6e5-59d3-4113-a17c-0e9f07b7dadb.woff2',
    },
    {
        font:'FangSong',
        url:'https://paper-airplane.oss-cn-beijing.aliyuncs.com/2024/09/03/3947dc25-7ecd-45b8-be0f-776b1d6ad612.woff2',
    },
    {
        font:'FangSong_GB2312',
        url:'https://paper-airplane.oss-cn-beijing.aliyuncs.com/2024/09/03/6e3b194f-1686-4511-a512-85dee48c520d.woff2',
    },
    {
        font:'Microsoft YaHei',
        url:'https://paper-airplane.oss-cn-beijing.aliyuncs.com/2024/09/03/afb4cf50-3faf-4e82-b9e1-271efe362e63.woff2',
    },
    {
        font:'SimHei',
        url:'https://paper-airplane.oss-cn-beijing.aliyuncs.com/2024/09/03/d3cd9a0e-9e66-4eea-b8fd-0adb24ec91e7.woff2',
    },
    {
        font:'Arial',
        url:'https://paper-airplane.oss-cn-beijing.aliyuncs.com/2024/09/03/04c56980-87b6-45ce-adf6-30c9405f0060.woff2',
    },
]
export default {
    getCustomFonts(){
        return custom_fonts
    }
}